export const resolvableServices = {
  ComplyAdvantage: true,
  Socure3: true,
  PlaidMonitor: true,
};
